// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__WvzPn","padding":"styles_padding__OqxvE","buttons":"styles_buttons__UMr6U","button":"styles_button__99n+N"};